/** 合約狀態 */
export enum ContractStatus {
  /** 新建立 */
  NEW = '0',
  /** 審核中 */
  APPROVING = '1',
  /** 駁回 */
  REJECTED = '2',
  /** 等待生效 */
  PENDING_ACTIVATION = '3',
  /** 取消生效 */
  CANCEL_PENDING = '4',
  /** 已生效 */
  ACTIVATED = '5',
  /** 不續約（停止合約） */
  NON_RENEWAL = '6',
  /** 異動審核中 */
  REVIEW_ADJUSTMENT = '7',
  /** 已過期（未解綁） */
  EXPIRED = '8',
  /** 已終止 */
  TERMINATED = '9',
  /** 未立案 */
  NOT_REGISTERED = '10',
  /** 合約失效 */
  INVALID = '11'
}
